<template>
  <div class="loginContainer" :style="{ 'background-image': `url(${bgUrl})` }">
    <div class="w">
      <div class="slogan web-font-banner-info" v-show="!isMobile">
        <span v-if="sloganUrl == 1">伯才<br />为劳动者创造价值</span>
        <span v-else>伯才稻田<br />赋能伙伴 合作共赢</span>
      </div>
      <div class="qcode">
        <!-- <div class="publicity">{{ publicity }}</div> -->
        <img :src="url" alt="" />
        <p>
          微信扫一扫<span>{{ info }}</span>
        </p>
      </div>
      <div class="slogan web-font-banner-info" v-show="isMobile">
        <span v-if="sloganUrl == 1">伯才<br />为劳动者创造价值</span>
        <span v-else>伯才稻田<br />赋能伙伴 合作共赢</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: "loginContainer",
  // 局部注册的组件
  components: {},
  // 组件参数 接收来自父组件的数据
  props: {
    isMobile: {
      require: true,
    },
  },
  // 组件状态值
  data() {
    return {
      url: require("../../assets/bcSVG/伯才直聘.png"),
      sloganUrl: 1,
      info: "进入伯才稻田",
      publicity: "职位查看、面试报名、入职一键搞定",
      bgUrl: require("../../assets/bcSVG/quickLoginBG.jpg"),
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    $route: {
      handler(to) {
        this.$nextTick(() => {
          if (to.query.id) {
            if (to.query.id == 1) {
              this.url = require("../../assets/bcSVG/bcQ.svg");
              if (!this.isMobile) {
                this.sloganUrl = 1;
              } else {
                this.sloganUrl = 1;
              }
              this.info = "进入伯才好工作";
              this.publicity = "职位查看、面试报名、入职一键搞定";
              this.bgUrl = require("../../assets/bcSVG/quickLoginBG.jpg");
            } else if (to.query.id == 2) {
              this.url = require("../../assets/bcSVG/dtQ.svg");
              if (!this.isMobile) {
                this.sloganUrl = 2;
              } else {
                this.sloganUrl = 2;
              }
              this.info = "进入伯才稻田";
              this.publicity = "流量推广、佣金结算综合平台";
              this.bgUrl = require("../../assets/bcSVG/daotianLoginBG.jpg");
            }
            window.scrollTo(0, 0);
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },

  // 生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.el 也在文档内。
   */
  mounted() {
    console.log(this.$route);
    console.log(this.isMobile);
  },
  // 组件方法
  methods: {},
};
</script>

<style scoped lang="less">
.loginContainer {
  width: 100vw;
  height: 100vh;
  // background: url("http://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/快速登录背景.jpg") no-repeat center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  > div {
    position: absolute;
    display: flex;
    // width: 1200px;
    justify-content: space-between;
    align-items: center;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    .slogan {
      flex: 1;
      span {
        color: #fff;
        font-size: 80px;
        font-weight: 100;
      }
      // img {
      // 	width: 771px;
      // }
    }
    .qcode {
      position: relative;
      width: 300px;
      height: 300px;
      border-radius: 4px;
      text-align: center;
      background-color: #0000005e;
      // border: 1px solid #eeeeee;
      .publicity {
        position: absolute;
        top: -40px;
        left: 50%;
        width: 120%;
        font-size: 18px;
        color: #fff;
        transform: translateX(-50%);
      }
      img {
        margin: 32px 0 20px 0;
        width: 190px;
        height: 190px;
      }
      p {
        color: #fff;
        font-size: 18px;
        // margin-top: 21px;
        span {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
